import { TooltipProvider, TooltipTrigger, TooltipContent, Tooltip as BaseTooltip } from "@/components/ui/tooltip";

export function Tooltip({
  label,
  children,
  asChild = false,
  side,
}: {
  asChild?: boolean;
  label: string;
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left" | undefined;
}) {
  return (
    <TooltipProvider>
      <BaseTooltip>
        <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
        <TooltipContent side={side}>
          <p>{label}</p>
        </TooltipContent>
      </BaseTooltip>
    </TooltipProvider>
  );
}
